import { FunctionComponent } from 'react';

export type SeparatorSunProps = {
  width: number;
  height: number;
  fill: string;
};

type FC = FunctionComponent<SeparatorSunProps>;

const SeparatorSun: FC = (props: SeparatorSunProps) => {
  const { width, height, fill } = props;

  return (
    <svg width={`${width}%`} height={`${height}%`} viewBox="0 0 619 924" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M581.056 -48L591.457 41.0833C601.858 130.167 623.403 308.333 618.203 486.5C613.002 664.667 581.056 842.833 564.711 931.917L548.367 1021L-50 1021L-50 931.917C-50 842.833 -50 664.667 -50 486.5C-50 308.333 -50 130.167 -50 41.0833L-50 -48L581.056 -48Z"
        fill={fill}
      />
    </svg>
  );
};

export default SeparatorSun;
